// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._18m91wug{overflow-y:auto}\n._1e0c1txw{display:flex}\n._1reo1wug{overflow-x:auto}\n._2lx21bp4{flex-direction:column}\n._kqswpfqs{position:static}", ""]);
// Exports
module.exports = exports;
